import React, { useContext, useRef, useEffect, useState } from 'react';
import { SrxApi } from '../api/SrxApi';
import { UserContext } from '../contexts/UserContext';

let credsFetchAttemptedRef = { attempted: false };

const VisionFrameworkPortal = ({ isCondensed }) => {
    const { user, setUser } = useContext(UserContext);
    const iframeRef = useRef(null);
    const credsFetchAttempted = credsFetchAttemptedRef;

    const updateUsers = (data) => {
        setUser(prev => ({
            ...prev,
            visionUsername: data.username,
            visionPassword: data.password
        }));
    };

    useEffect(() => {
        const iframe = iframeRef.current;

        const login = (username = false, password = false) => {
            if (((username && password) || (user.visionUsername && user.visionPassword)) && iframe) {
                iframe.contentWindow.postMessage({
                    username: username || user.visionUsername,
                    password: password || user.visionPassword
                }, process.env.REACT_APP_VISION_HOST);
            }
        };

        const tryFetchAndLogin = async () => {
            const shouldClearSession = localStorage.getItem('clear_vision_session');
            if (shouldClearSession === 'true') {
                // post message to iframe to clear session
                if (iframe) {
                    iframe.contentWindow.postMessage("CLEAR_SESSION", process.env.REACT_APP_VISION_HOST);
                    localStorage.removeItem('clear_vision_session');
                }
            }

            if (user.visionUsername && user.visionPassword) {
                login();
                return;
            }

            if (credsFetchAttempted.attempted) return;

            try {
                const response = await SrxApi.get('/vision-credentials');
                const data = response.data || {};

                if (data.username && data.password) {
                    updateUsers(data);
                    // We need to pass credentials to login
                    // because we can't rely on the amazing React framework setUser
                    // to update in time and we would have to use the super fancy hook approach
                    // which any good framework doesn't need because they were actually developed by people
                    // who know what they are doing.
                    login(data.username, data.password);
                } else {
                    credsFetchAttempted.attempted = true;
                }
            } catch (err) {
                credsFetchAttempted.attempted = true;
            }
        };

        const logout = async () => {
            try {
                await SrxApi.delete('/vision-logout');
                updateUsers({ username: null, password: null });
            } catch (err) {
                console.error('Failed to logout:', err);
            }
        }

        const handleIframeMessage = async (event) => {
            if (event.origin !== process.env.REACT_APP_VISION_HOST) return;

            if (event.data === "VISION_READY") return tryFetchAndLogin();

            if (event.data === "VISION_LOGOUT") return logout();

            const { username, password } = event.data || {};
            if (username && password) {
                try {
                    await SrxApi.post('/vision-credentials', { username, password });
                    updateUsers({ username, password });
                } catch (err) {
                    console.error('Failed to save credentials:', err);
                }
            }
        };

        window.addEventListener('message', handleIframeMessage);

        return () => {
            window.removeEventListener('message', handleIframeMessage);
            if (iframe) {
                iframe.removeEventListener('load', tryFetchAndLogin);
            }
        };
    }, [user]);

    return (
        <section className="vision w-100" style={{height: 'calc(100vh - 150px)'}}>
            <iframe ref={iframeRef} className="h-100 w-100" id="vision-iframe" style={{border: 'none'}} src={`${process.env.REACT_APP_VISION_URL}`}></iframe>
        </section>
    )
}

export default VisionFrameworkPortal;